import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import { BaseControl, FormToggle } from '@wordpress/components';
import { Component, createRef } from '@wordpress/element';
import { DOWN, ENTER, SPACE, UP } from '@wordpress/keycodes';
import PropTypes from 'prop-types';
/**
 * `MenuItem` is used to give the item an accessible wrapper, with the `menuitem` role and added keyboard functionality (`onInvoke`).
 * `MenuItem`s can also be deemed "clickable", though this is disabled by default because generally the inner component handles
 * the click event.
 */

var MenuItem =
/*#__PURE__*/
function (_Component) {
  _inherits(MenuItem, _Component);

  function MenuItem() {
    var _this;

    _classCallCheck(this, MenuItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MenuItem).apply(this, arguments));
    _this.onClick = _this.onClick.bind(_assertThisInitialized(_this));
    _this.onFocusFormToggle = _this.onFocusFormToggle.bind(_assertThisInitialized(_this));
    _this.onKeyDown = _this.onKeyDown.bind(_assertThisInitialized(_this));
    _this.container = createRef();
    return _this;
  }

  _createClass(MenuItem, [{
    key: "onClick",
    value: function onClick(event) {
      var _this$props = this.props,
          isClickable = _this$props.isClickable,
          onInvoke = _this$props.onInvoke;

      if (isClickable) {
        event.preventDefault();
        onInvoke();
      }
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(event) {
      if (event.target.isSameNode(event.currentTarget)) {
        if (event.keyCode === ENTER || event.keyCode === SPACE) {
          event.preventDefault();
          this.props.onInvoke();
        }

        if (event.keyCode === UP) {
          event.preventDefault();
        }

        if (event.keyCode === DOWN) {
          event.preventDefault();
          var nextElementToFocus = event.target.nextSibling || event.target.parentNode.querySelector('.woocommerce-ellipsis-menu__item');
          nextElementToFocus.focus();
        }
      }
    }
  }, {
    key: "onFocusFormToggle",
    value: function onFocusFormToggle() {
      this.container.current.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          checked = _this$props2.checked,
          children = _this$props2.children,
          isCheckbox = _this$props2.isCheckbox;

      if (isCheckbox) {
        return createElement("div", {
          "aria-checked": checked,
          ref: this.container,
          role: "menuitemcheckbox",
          tabIndex: "0",
          onKeyDown: this.onKeyDown,
          onClick: this.onClick,
          className: "woocommerce-ellipsis-menu__item"
        }, createElement(BaseControl, {
          className: "components-toggle-control"
        }, createElement(FormToggle, {
          "aria-hidden": "true",
          checked: checked,
          onChange: this.props.onInvoke,
          onFocus: this.onFocusFormToggle,
          onClick: function onClick(e) {
            return e.stopPropagation();
          },
          tabIndex: "-1"
        }), children));
      }

      return createElement("div", {
        role: "menuitem",
        tabIndex: "0",
        onKeyDown: this.onKeyDown,
        onClick: this.onClick,
        className: "woocommerce-ellipsis-menu__item"
      }, children);
    }
  }]);

  return MenuItem;
}(Component);

MenuItem.propTypes = {
  /**
   * Whether the menu item is checked or not. Only relevant for menu items with `isCheckbox`.
   */
  checked: PropTypes.bool,

  /**
   * A renderable component (or string) which will be displayed as the content of this item. Generally a `ToggleControl`.
   */
  children: PropTypes.node,

  /**
   * Whether the menu item is a checkbox (will render a FormToggle and use the `menuitemcheckbox` role).
   */
  isCheckbox: PropTypes.bool,

  /**
   * Boolean to control whether the MenuItem should handle the click event. Defaults to false, assuming your child component
   * handles the click event.
   */
  isClickable: PropTypes.bool,

  /**
   * A function called when this item is activated via keyboard ENTER or SPACE; or when the item is clicked
   * (only if `isClickable` is set).
   */
  onInvoke: PropTypes.func.isRequired
};
MenuItem.defaultProps = {
  isClickable: false,
  isCheckbox: false
};
export default MenuItem;
//# sourceMappingURL=menu-item.js.map